import { combineReducers } from 'redux';
import userActions from './reducer_user_actions';
import userState from './reducer_user_states';
import workBarSelected from './reducer_workBar_selected';
import messagesToSM from './reducer_messages_to_SM';
import noAvailableState from './reducer_no_available';
import validatingTelephonyState from './reducer_validating_telephony';
import otherActions from './reducer_other_actions';
import callActionsACD from './reducer_call_acd';
import consultingCounter from './reducer_consulting';
import stateMachineActions from './reducer_actions_from_SM';
import windowVisible500 from './reducer_window_visible500';
import queueCount from './reducer_queue_count';
import sipClientActions from './reducer_sip_client_actions';
import dragWindowController from './reducer_draggable_windows_controller';
import blockingPanelReducer from './reducer_blocking_panel';
import volumeControl from './reducer_volume';
import assistedTransfer from './reducer_assisted_transfer';
import messagesIntegrations from './reducer_actions_integration';
import isAlertModalOpen from './reducer_alert_modal';
import isOngoingCallIvrModalOpen from './reducer_ongoing_call_ivr_modal';
import unifiedInboxState from './reducer_unified_inbox';
import whiteLabelState from './reducer_white_label';
import localLogState from './reducer_localLogging';
import previewActions from './reducer_preview_transfer';
import preview from './reducer_preview';
import adminModal from './reducer_admin_alert_modal';
import agentPermissions from './reducer_agent_permissions';
import setFlagShowAlert from './reducer_psw_reset';
import manualMessageReducer from './reducer_manual_message';
import transferReducer from './reducer_transfer';

export default combineReducers({
	userActions,
	userState,
	workBarSelected,
	messagesToSM,
	noAvailableState,
	validatingTelephonyState,
	otherActions,
	callActionsACD,
	consultingCounter,
	stateMachineActions,
	windowVisible500,
	queueCount,
	dragWindowController,
	sipClientActions,
	blockingPanelReducer,
	volumeControl,
	assistedTransfer,
	messagesIntegrations,
	isAlertModalOpen,
	isOngoingCallIvrModalOpen,
	unifiedInboxState,
	whiteLabelState,
	localLogState,
	previewActions,
	preview,
	adminModal,
	agentPermissions,
	setFlagShowAlert,
	manualMessageReducer,
	transferReducer
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js